<div class="wrapper">
    <div class="m-box">
        <h2>
          <!-- Cancelled Appointments Search -->
          {{'appointments.gui.labels.Canceled Appointments Search' | translate}}
        </h2>
        <div class="margin-div">
            <!-- From -->
            {{'appointments.gui.labels.From' | translate}}
            <input [matDatepicker]="startDatepicker"  [(ngModel)]="startDate" (ngModelChange)="onStartDateChange($event)"   class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP" (click)="startDatepicker.open()">
            <mat-datepicker #startDatepicker></mat-datepicker>
            <!-- Until -->
            {{'appointments.gui.labels.Until' | translate}}
            <input [matDatepicker]="endDatepicker"  [(ngModel)]="endDate" (click)="endDatepicker.open()" (ngModelChange)="onEndDateChange($event)" class="t-field t-field--date menstural-field" aria-labelledby="menstural_LMP">
            <mat-datepicker #endDatepicker></mat-datepicker>
            <button class="orange-btn" [matTooltip]="'appointments.gui.tooltips.Search Appointments' | translate"   matTooltipPosition="after" (click)="search()" >
              <!-- Search -->
              {{'appointments.gui.buttons.Search' | translate}}
            </button>
           </div>
           <div  class="search-results">
            <table *ngIf="deletedAppointments && deletedAppointments.length">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      <!-- Appointment -->
                      {{'appointments.gui.labels.Appointment' | translate}}
                    </th>
                    <th>
                      <!-- Date -->
                      {{'appointments.gui.labels.Date' | translate}}
                    </th>
                    <th>
                      <!-- Patient Name -->
                      {{'appointments.gui.labels.Patient Name' | translate}}
                    </th>
                    <th>
                      <!-- Patient ID -->
                      {{'appointments.gui.labels.Patient ID' | translate}}
                    </th>
                    <th *ngIf="!ls?.premissions?.ApptsByRoom">
                      <!-- Doctor -->
                      {{'appointments.gui.labels.Doctor' | translate}}
                    </th>
                    <th><img
                        style="cursor: pointer"
                        [matTooltip]="'appointments.gui.tooltips.Download CVS' | translate"
                        (click)="exportExcel()"
                       height="31em"
                        width="31em"
                        src="../../assets/icons/fileblue.svg"
                          /></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let appointment of deletedAppointments | sortByDateTime; let i = index">
                    <td>{{i + 1}} </td>
                    <td>    {{ getTranslatedExamType(appointment.examType) }}</td>
                    <td>{{ appointment.aptTime | date:"dd.MM.yyyy HH:mm"}}</td>
                    <td>{{ appointment.First }} {{ appointment.Last }}</td>
                    <td>{{ appointment.ID }}</td>
                    <td *ngIf="appointment.Name">{{ appointment.Name }}</td>
                  </tr>
                </tbody>
              </table>
         </div>
    </div>
</div>
